export const notificationsType = {
    chat:{
        icon:'i-Speach-Bubble-6',
        bg:'#df6d14',
    },
    to:{
        icon:'i-Car-2',
        bg:'#808080',
    },
    shipment:{
        icon:'i-Plane',
        bg:'#03224c',
    },
    salesOrder:{
        icon:'i-Shopping-Basket',
        bg:'#000000',
    },
    item:{
        icon:'i-Shopping-Basket',
        bg:'#c73b5e',
    },
    rppslPack:{
        icon:'i-Book-17',
        bg:'#6a0dad',
    },
    licence_notification:{
        icon:'i-Bell',
        bg:'#6B21A8',
    }
};